import React from 'react';
import ReactDOM from 'react-dom';


import '../../styles/chapter2/interview_question_stack.scss';

class Interview_questions extends React.Component{

	constructor(props){
		super(props);
	}


	render(){
		return (
			<div className="question-stack">
				<div className="question-stack-inner">
					<h2>Question {this.props.currentQuestion}/5</h2>
					{this.props.data.map(function(d,index){
							return (<button className="question-inteview-button" onClick={(event)=>this.props.selectQuestion(event,d)}>{d.frage}</button>);			
					}.bind(this))}
				</div>
			</div>);
	}
}


export default Interview_questions;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/interview_questions.js